export default (pageName) => {

	return ({ app }) => {
		// app.page.setAttribute('lang', app.loc);
		app.page.setAttribute('data-page-name', pageName);

	};

};